<template>

</template>

<script>
export default {
  name: "FAQPage"
}
</script>


